export const baseTemplete = (data) => {
  const { refEntity, gridMeta } = data
  const viewApplication = gridMeta.viewApplication
  const viewmodel = gridMeta.viewmodel
  const newTemp = { // viewmodel-viewApplication
    refEntity,
    gridMeta: {
      nfwFeData: {
        enumData: {},
        enumTypes: [],
        libCode: 'ynf-lib-base',
        busiObj: viewmodel.busiObjCode,
        tplPubts: 1702884361842, // 应该也是时间戳
        nid: 'nid_154',
        caption: viewApplication.cBillName,
        appCode: viewApplication.key, // 不确定
        defaultTplId: viewApplication.defTplId,
        userDefines: [],
        permissions: {
          auth: [
            {
              authName: '公共越权',//@notranslate
              authFlag: true
            }
          ]
        },
        pubts: viewApplication.property,
        billNo: viewApplication.cBillNo,
        ynfVersion: '1',
        billType: 'VoucherList',
        billPubts: 1702884361838, // 单据更新时间戳
        // 'ytenant_id': '0000LIVC1ACC5D6J9G0000',
        detailBillNo: '',
        controlType: 'Bill',
        ownDomain: 'developplatform',
        billId: viewApplication.billid,
        tplMode: 0,
        tplId: viewApplication.view.iTplId,
        actions: {
          CommonCommand: {
            authName: '公共越权',//@notranslate
            action: 'CommonCommand',
            params: {}
          }
        },
        children: [
          { ...typeTemplete(data, 'view') }, // ui模板
          {
            controlType: 'FunctionLib',
            children: [],
            nid: 'nid_64',
            caption: '函数库',//@notranslate
            orderNum: 2
          },
          {
            controlType: 'Stores',
            children: [
              { // 表有的--能不能通用
                libCode: 'ynf-core-engine',
                storeType: 'PagingStore',
                compType: 'xcontainer',
                visible: true,
                controlType: 'PagingStore',
                nid: 'nid_98',
                alias: 'pagingStore',
                caption: 'pagingStore',
                disabled: false
              },
              {
                libCode: 'ynf-core-engine',
                storeType: 'FilterStore',
                compType: 'xcontainer',
                visible: true,
                controlType: 'FilterStore',
                nid: 'nid_99',
                alias: 'filterStore',
                caption: 'filterStore',
                disabled: false
              },

              { // 树有的--能不能通用
                libCode: "ynf-core-engine",
                storeType: "CardStore",
                compType: "xcontainer",
                visible: true,
                controlType: "CardStore",
                formStore: "formStore",
                nid: "nid_74",
                alias: "cardStore",
                caption: "cardStore",
                disabled: false,
                dataSource: "mainEntity"
              },
              { // 可以不用
                libCode: "ynf-core-engine",
                controlType: "FormStore",
                nid: "nid_76",
                alias: "formStore",
                caption: "formStore",
                type: "entity",
                fieldsArr: [
                  {
                    bizType: "text",
                    field: "ziduan1",
                    nid: "nid_77",
                    alias: "ziduan1",
                    caption: "树1",//@notranslate
                    virtualField: false
                  }
                ]
              },
              ...typeTemplete(data, 'store')
            ],
            nid: 'nid_stores_132',
            caption: 'Stores',
            orderNum: 3
          },
          {
            controlType: 'Reactions',
            children: [
              // {
              //   'filter': 'filterStore',
              //   'libCode': 'ynf-core-engine',
              //   'compType': 'xcontainer',
              //   'visible': true,
              //   'controlType': 'ListReaction',
              //   'nid': 'nid_133',
              //   'alias': 'ListReaction134',
              //   'caption': 'listReaction',
              //   'dataSourceAlias': 'mainEntity',
              //   'disabled': false,
              //   'paging': 'pagingStore',
              //   'list': 'tableStore'
              // }
            ],
            nid: 'nid_reactions_135',
            alias: 'reactions',
            caption: 'Reactions',
            orderNum: 4
          },
          {
            controlType: 'Actions',
            children: [
              {
                libCode: "ynf-core-engine/actions/navigate",
                controlType: "openBillByRoute",
                nid: "nid_openBillByRoute_137",
                alias: "openBillByRoute",
                caption: "新增",//@notranslate
                params: {
                  mode: "add",
                  billNo: "",
                  url: "/bill/add"
                }
              },
              {
                libCode: "ynf-core-engine/actions/bill",
                controlType: "editByRow",
                nid: "nid_editByRow_140",
                alias: "editByRow",
                caption: "编辑",//@notranslate
                params: {
                  billNo: "",
                  url: "/bill/edit"
                }
              }
            ],
            nid: 'nid_actions_136',
            alias: 'actions',
            caption: 'Actions',
            orderNum: 5
          }
        ]
      }
    }
  }
  return newTemp
}

const typeTemplete = (data, type) => {
  let view = {}
  let store = {}
  if (['Table'].includes(data.refEntity.cTpltype)) {
    // const table = data.gridMeta.viewmodel.entities.find(e => e.cControlType.toLocaleLowerCase() === 'table')
    const table = data.gridMeta.viewApplication.view.containers.find(e => ['table', 'treetable'].includes(e.cControlType.toLocaleLowerCase()))

    view = {
      controlType: 'BillTemplate',
      children: [
        {
          libCode: 'ynf-lib-base',
          rowSelection: {
            multiple: true
          },
          visible: true,
          entityType: 'main',
          nid: 'nid_1',
          caption: '表格',//@notranslate
          orderNum: 1,
          store: 'mobx://rootStore.tableStore',
          serialCode: '1887074292044136457',
          compType: 'xcontainer',
          controlType: 'Table',
          // children: table.fields.filter(e => !e.bHidden).map((item, idx) => {
          children: table.controls.map((item, idx) => {
            return {
              ...item,
              libCode: 'ynf-lib-base',
              visible: item.bShowIt,
              nid: 'nid_' + idx,
              caption: item.cShowCaption || item.cCaption,
              orderNum: idx + 1,
              store: 'tableStore',
              serialCode: item.id,
              required: false,
              parentSerialCode: '1887074292044136457',
              compType: 'xcontrol',
              controlType: 'Input',
              colWidth: item.iColWidth,
              storeField: item.cItemName,
              alias: item.cName,
              disabled: false,
              value: `mobx://rowStore.getValue('${item.cItemName}')`,
              ...columns(item)
            }
          }).concat([{ // 表格的行按钮-看后续是否用
            libCode: 'ynf-lib-base',
            parentSerialCode: '1887074292044136457',
            compType: 'xcontainer',
            controlType: 'ToolBar',
            children: [
              {
                libCode: "ynf-lib-base",
                onClick: "mobx://rootStore.actions.referEdit.doAction",
                visible: "mobx://rootStore.referStore.btnEditVisible",
                nid: "nid_59",
                caption: "新增",//@notranslate
                orderNum: 1,
                serialCode: "1887074292044136487",
                parentSerialCode: "1887074292044136486",
                compType: "xbutton",
                controlType: "Button",
                alias: "btnAdd",
                disabled: "mobx://rootStore.formStore.isMasterOrgField",
                iStyle: 1
              },
              {
                libCode: "ynf-lib-base",
                onClick: "mobx://rootStore.actions.referAdd.doAction",
                visible: "mobx://rootStore.referStore.btnAddVisible",
                nid: "nid_60",
                caption: "编辑",//@notranslate
                orderNum: 2,
                serialCode: "1887074292044136488",
                parentSerialCode: "1887074292044136486",
                compType: "xbutton",
                controlType: "Button",
                alias: "btnEdit",
                disabled: "mobx://rootStore.formStore.isMasterOrgField",
                iStyle: 1
              }
            ],
            nid: 'nid_ToolBar_58',
            alias: 'rowtoolbar59',
            caption: '按钮栏',//@notranslate
            orderNum: 29,
            isFoldAble: true,
            store: 'mobx://rowStore',
            serialCode: '1887074292044136486'
          }]),
          alias: 'maintable',
          disabled: false,
          onRowDoubleClick: 'onDoubleClick'
        },
        {
          libCode: 'ynf-lib-base',
          visible: true,
          onChange: 'mobx://rootStore.pagingStore.onChange',
          nid: 'nid_pagination_0',
          pageInfo: 'mobx://rootStore.pagingStore.pageInfo',
          caption: '分页器',//@notranslate
          orderNum: 2,
          serialCode: '1887074292044136490',
          compType: 'xcontainer',
          controlType: 'Pagination',
          alias: 'Pagination63',
          disabled: false,
          topStyle: {
            justifyContent: 'end'
          }
        }
      ],
      nid: 'nid_0',
      caption: '参照-表详情(参照)',//@notranslate
      orderNum: 1
    }

    store = [{
      libCode: 'ynf-core-engine',
      storeType: 'TableStore',
      cCode: 'canzhaolianxiang_biao_6f45365ed4074b5cb4989ad00134c4d3',
      cPrimaryKey: 'id',
      nid: 'nid_100',
      caption: 'tableStore',
      cDataSourceName: 'AT1A2594420A480009.AT1A2594420A480009.canzhaolianxiang_biao',
      type: 'entity',
      bMain: true,
      controlType: 'TableStore',
      cName: 'mdf参照',//@notranslate
      alias: 'tableStore',
      bIsNull: '',
      // fieldsArr: table.fields.map((item, idx) => {
      fieldsArr: table.controls.map((item, idx) => {
        return {
          ...item,
          // 'bizType': 'text', // 这里是业务类型----------------------------------
          nid: 'nid_store_' + idx,
          caption: item.cCaption,
          virtualField: item.bVmExclude !== 2, // 是否真实字段
          cName: item.cItemName,
          alias: item.cItemName,
          iMaxLength: '200',
          field: item.cFieldName, // 查询字段
          // 'cEnumString': '',
          enumType: item.cItemName
        }
      })
    }]
  } else if (['Tree'].includes(data.refEntity.cTpltype)) {
    const controls = data.gridMeta.viewApplication.view.containers.find(e => ['searchtree', 'table'].includes(e.cControlType.toLocaleLowerCase()))?.controls || []
    view = {
      controls: controls.map((item, idx) => {
        return {
          ...item,
          libCode: 'ynf-lib-base',
          visible: item.bShowIt && !item.bHidden,
          nid: 'nid_' + idx,
          caption: item.cShowCaption || item.cCaption,
          orderNum: idx + 1,
          store: 'tableStore',
          serialCode: item.id,
          required: false,
          parentSerialCode: '1887074292044136457',
          compType: 'xcontrol',
          controlType: 'Input',
          colWidth: item.iColWidth,
          storeField: item.cItemName,
          alias: item.cName,
          disabled: false,
          value: `mobx://rowStore.getValue('${item.cItemName}')`,
          ...columns(item)
        }
      }),
      controlType: "BillTemplate",
      children: [
        {
          libCode: "ynf-lib-base",
          visible: true,
          selectedKeys: "mobx://rootStore.treeStore.selectedKeys",
          modelPath: ["canzhao_tree"],
          nid: "nid_1",
          caption: "树形控件",//@notranslate
          editEvent: "mobx://rootStore.treeStore.editEvent",
          nodeEvents: [
            // {
            //     "icon": "uf-plus",
            //     "event": "addEvent"
            // },
          ],
          orderNum: 1,
          serialCode: "1887074128835379205",
          onSelect: "mobx://rootStore.treeStore.onSelect",
          addEvent: "mobx://rootStore.treeStore.addEvent",
          compType: "xcontrol",
          controlType: "Tree",
          delEvent: "mobx://rootStore.treeStore.delEvent",
          showButton: true,
          showSearch: true,
          alias: "referTree",
          cStyle: {
            heighe: "100%",
            felx: 1
          },
          showAddRootNode: false,
          disabled: false,
          dataSource: "mobx://rootStore.treeStore.dataSource"
        }
      ],
      nid: "nid_0",
      caption: "参照-树(MDF)",//@notranslate
      orderNum: 1
    }
    store = [{
      libCode: "ynf-core-engine",
      storeType: "TreeStore",
      compType: "xcontainer",
      visible: true,
      controlType: "TreeStore",
      nid: "nid_73",
      alias: "treeStore",
      caption: "treeStore",
      disabled: false
    }]
  } else if (['TreeTable'].includes(data.refEntity.cTpltype)) {
    // const table = data.gridMeta.viewmodel.entities.find(e => e.cControlType.toLocaleLowerCase() === 'table')
    const table = data.gridMeta.viewApplication.view.containers.find(e => ['table', 'treetable'].includes(e.cControlType.toLocaleLowerCase()))
    const cDataSourceName = data.gridMeta.viewmodel.entities.find(e => e.cDataSourceName).cDataSourceName
    view = {
      controlType: "BillTemplate",
      children: [
        {
          libCode: "ynf-lib-layout",
          visible: true,
          compType: "xcontainer",
          controlType: "Layout",
          children: [
            {
              libCode: "ynf-lib-view",
              selectedKeys: "mobx://rootStore.treeStore.selectedKeys",
              modelPath: [
                "sstList"
              ],
              nid: "nid_3",
              caption: "树形控件1",//@notranslate
              nodeEvents: [],
              orderNum: 1,
              serialCode: "1816444955108311045",
              onSelect: "mobx://rootStore.treeStore.onSelect",
              // "addEvent": "mobx://rootStore.treeStore.addEvent",
              compType: "xcontrol",
              // "delEvent": "mobx://rootStore.treeStore.delEvent",
              showSearch: true,
              alias: "tree1oi",
              disabled: false,
              visible: true,
              checkable: false,
              multiple: false,
              // "editEvent": "mobx://rootStore.treeStore.editEvent",
              parentSerialCode: "1816444955108311044",
              controlType: "Tree",
              showButton: true,
              cStyle: {
                // "width": "240px",
                // "height": "100%"
              },
              showAddRootNode: false,
              dataSource: "mobx://rootStore.treeStore.dataSource",
              foreignKey: "sst1"
            },
            {
              libCode: "ynf-lib-view",
              rowSelection: {
                multiple: true
              },
              visible: true,
              entityType: "main",
              modelPath: [
                "subst"
              ],
              nid: "nid_4",
              caption: "表格4",//@notranslate
              orderNum: 2,
              store: "mobx://rootStore.tableStore",
              serialCode: "1816444955108311046",
              parentSerialCode: "1816444955108311044",
              compType: "xcontainer",
              controlType: "Table",
              // children: table.fields.filter(e => !e.bHidden).map((item, idx) => {
              children: table.controls.map((item, idx) => {
                return {
                  ...item,
                  libCode: 'ynf-lib-base',
                  visible: item.bShowIt,
                  nid: 'nid_' + idx,
                  caption: item.cShowCaption || item.cCaption,
                  orderNum: idx + 1,
                  store: 'tableStore',
                  serialCode: item.id,
                  required: false,
                  parentSerialCode: '1887074292044136457',
                  compType: 'xcontrol',
                  controlType: 'Input',
                  colWidth: item.iColWidth,
                  storeField: item.cItemName,
                  alias: item.cName,
                  disabled: false,
                  value: `mobx://rowStore.getValue('${item.cItemName}')`,
                  ...columns(item)
                }
              }).concat([{ // 表格的行按钮-看后续是否用
                libCode: 'ynf-lib-base',
                parentSerialCode: '1887074292044136457',
                compType: 'xcontainer',
                controlType: 'ToolBar',
                children: [
                  {
                    libCode: 'ynf-lib-base',
                    onClick: 'copyRow_',
                    visible: 'mobx://rootStore.formStore.isEdit',
                    nid: 'nid_59',
                    caption: '复制行',//@notranslate
                    orderNum: 1,
                    serialCode: '1887074292044136487',
                    parentSerialCode: '1887074292044136486',
                    compType: 'xbutton',
                    controlType: 'Button',
                    alias: 'btnCopyRow_',
                    disabled: 'mobx://rootStore.formStore.isMasterOrgField',
                    iStyle: 1
                  }
                ],
                nid: 'nid_ToolBar_58',
                alias: 'rowtoolbar59',
                caption: '按钮栏',//@notranslate
                orderNum: 29,
                isFoldAble: true,
                store: 'mobx://rowStore',
                serialCode: '1887074292044136486'
              }]),
              alias: "maintable",
              cStyle: {
                // "flex": "1",
                // "height": "100%"
              },
              disabled: false,
              onRowDoubleClick: "onDoubleClick"
            }
          ],
          nid: "nid_1",
          caption: "布局容器",//@notranslate
          orderNum: 1,
          alias: "Layout2",
          cStyle: {
            display: "flex",
            height: "100%"
          },
          disabled: false,
          serialCode: "1816444955108311044"
        },
        {
          libCode: "ynf-lib-nav",
          visible: true,
          onChange: "mobx://rootStore.pagingStore.onChange",
          nid: "nid_93",
          pageInfo: "mobx://rootStore.pagingStore.pageInfo",
          caption: "分页器",//@notranslate
          orderNum: 2,
          serialCode: "1816444955108311093",
          compType: "xcontainer",
          controlType: "Pagination",
          alias: "Pagination94",
          disabled: false,
          topStyle: {
            justifyContent: "end"
          }
        }
      ],
      nid: "nid_0",
      orderNum: 1,
      cTemplateName: "树表参照新新详情(参照)"//@notranslate
    }
    store = [{
      libCode: "ynf-core-engine",
      storeType: "TreeStore",
      compType: "xcontainer",
      visible: true,
      controlType: "TreeStore",
      nid: "nid_73",
      alias: "treeStore",
      caption: "treeStore",
      disabled: false
    }, {
      libCode: "ynf-core-store",
      storeType: "TableStore",
      cCode: "subst_2f98c053206443f2a45ebb3988d45e5c",
      cPrimaryKey: "id",
      nid: "nid_199",
      caption: "tableStore",
      cDataSourceName,
      type: "entity",
      bMain: true,
      controlType: "TableStore",
      cName: "树表实体",//@notranslate
      alias: "tableStore",
      bIsNull: "",
      // fieldsArr: table.fields.map((item, idx) => {
      fieldsArr: table.controls.map((item, idx) => {
        return {
          ...item,
          // 'bizType': 'text', // 这里是业务类型----------------------------------
          nid: 'nid_store_' + idx,
          caption: item.cCaption,
          virtualField: item.bVmExclude !== 2, // 是否真实字段
          cName: item.cItemName,
          alias: item.cItemName,
          iMaxLength: '200',
          field: item.cFieldName, // 查询字段
          // 'cEnumString': '',
          enumType: item.cEnumType
        }
      }).concat([{ // 表格的行按钮-看后续是否用
        libCode: 'ynf-lib-base',
        parentSerialCode: '1887074292044136457',
        compType: 'xcontainer',
        controlType: 'ToolBar',
        children: [
          {
            libCode: "ynf-lib-base",
            onClick: "add",
            onClick: "mobx://rootStore.actions.referEdit.doAction",
            visible: "mobx://rootStore.referStore.btnEditVisible",
            nid: "nid_59",
            caption: "新增",//@notranslate
            orderNum: 1,
            serialCode: "1887074292044136487",
            parentSerialCode: "1887074292044136486",
            compType: "xbutton",
            controlType: "Button",
            alias: "btnAdd",
            disabled: "mobx://rootStore.formStore.isMasterOrgField",
            iStyle: 1
          },
          {
            libCode: "ynf-lib-base",
            onClick: "mobx://rootStore.actions.referAdd.doAction",
            visible: "mobx://rootStore.referStore.btnAddVisible",
            nid: "nid_60",
            caption: "编辑",//@notranslate
            orderNum: 2,
            serialCode: "1887074292044136488",
            parentSerialCode: "1887074292044136486",
            compType: "xbutton",
            controlType: "Button",
            alias: "btnEdit",
            disabled: "mobx://rootStore.formStore.isMasterOrgField",
            iStyle: 1
          }
        ],
        nid: 'nid_ToolBar_58',
        alias: 'rowtoolbar59',
        caption: '按钮栏',//@notranslate
        orderNum: 29,
        isFoldAble: true,
        store: 'mobx://rowStore',
        serialCode: '1887074292044136486'
      }]),
    }]
  }

  return { view, store }[type] || { view, store }
}

const columns = (item) => {
  const common = {}
  common.modelPath = [item.cItemName];
  common.sorter = true; // 列排序
  common.readOnly = true; // 全都是只读不能修改
  common.caption_resid = item.cShowCaptionResid;
  common.cStyle = null

  const controlType = item.cControlType.toLocaleLowerCase()
  if (controlType === 'tag' || controlType === 'refer') { // 渲染该列为参照组件
    let showRefReturn = item.refReturn;
    if (item.cControlType === 'tag') {
        const keyMap = JSON.parse(item.cRefRetId);
        for (const res in keyMap) {
        if (keyMap[res] === showRefReturn) {
          showRefReturn = res;
        }
      }
    }

    const refReturn = showRefReturn || 'name';
    return {
      ...common,
      cItemName: item.depend && item.characterKey ? item.cItemName + '_name' : item.cItemName,
      selectType: item.cControlType === 'tag' ? 'multiple' : 'single',
      refCode: item.cRefType,
      refReturn: Array.isArray(refReturn) ? refReturn: [refReturn],
      refReturnArr: `{"${refReturn}": "${item.store},${item.cItemName}"}`,
      controlType: 'ReferInput',
      libCode: 'ynf-fw-apcom-lib',
      dataSourceAlias: controlType === 'tag' ? item.cDataSourceName : item.dataSourceAlias,
    }
  } else if (['optionwidget', 'radio', 'select'].includes(controlType)) { // 渲染该列为枚举组件
    return { ...common, controlType: 'Enumerate' }
  } else if (['switch'].includes(controlType)) { // 渲染该列为枚举组件
    return { ...common, cEnumString: JSON.stringify({true: '是', false: '否'}), controlType: 'Enumerate' }//@notranslate
  } else if (['avatar'].includes(controlType)) {
    return { ...common, controlType: 'Avatar'}
  } else if (['datepicker', 'datetimepicker', 'timepicker'].includes(controlType)) { // 'predicatedatepicker'
    const enumData = { 'datepicker': 'DatePicker', 'datetimepicker': 'DateTimePicker', 'timepicker': 'TimePicker' }
    common.format = item.cFormateData
    return { ...common, controlType: enumData[controlType] }
  } else if (['timerangepicker', 'rangepicker'].includes(controlType)) {
    common.format = item.cFormateData
    return { ...common, controlType: 'DateRangePicker' }
  } else {
    return { ...common, controlType: 'Input' }
  }
}
